import { BrowserRouter, Route, Routes } from "react-router";
import InvoicePayment from "./pages/invoice-payment";
import InvoicePdf from "./pages/invoice-pdf";
import CheckoutPayment from "./pages/checkout-payment";
import CustomerPortal from "./pages/customer-portal";
import Home from "./pages/index";
import NotFound from "./pages/not-found";
import { Checkoutv1Redirect } from "./pages/checkoutv1-redirect";
import { Checkoutv1Success } from "./pages/checkoutv1-success";
import { Checkoutv1Cancel } from "./pages/checkoutv1-cancel";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/invoice/:invoiceId" element={<InvoicePayment />} />
        <Route path="/invoice/:invoiceId/pdf" element={<InvoicePdf />} />
        <Route path="/checkout/:paymentLinkId" element={<CheckoutPayment />} />
        <Route path="/portal/:stripeCustomerId" element={<CustomerPortal />} />
        <Route path="/checkoutv1/success" element={<Checkoutv1Success />} />
        <Route path="/checkoutv1/cancel" element={<Checkoutv1Cancel />} />
        <Route path="/checkoutv1/404" element={<NotFound />} />
        <Route path="/checkoutv1/:id" element={<Checkoutv1Redirect />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
